import { Component, Input, OnInit, inject } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { PatientAttachmentsService } from '../../../core/services/patient-attachments.service';
import { ConsultNoteSelectSpecialtyComponent } from '../consult-note-select-specialty/consult-note-select-specialty.component';
import { ValidatePrescriberMatchComponent } from '../validate-prescriber-match/validate-prescriber-match.component';
import { ValidatePatientMatchComponent } from '../validate-patient-match/validate-patient-match.component';
import { ValidateSpecialistEncounterComponent } from '../validate-specialist-encounter/validate-specialist-encounter.component';
import { ValidateDrugDetailsComponent } from '../validate-drug-details/validate-drug-details.component';

@Component({
    selector: 'app-patient-document-form',
    templateUrl: './patient-document-form.component.html',
    imports: [ConsultNoteSelectSpecialtyComponent,
              ValidatePrescriberMatchComponent,
              ValidatePatientMatchComponent,
              ValidateSpecialistEncounterComponent,
              ValidateDrugDetailsComponent]
})
export class PatientDocumentFormComponent implements OnInit {
  private patientAttachmentsService = inject(PatientAttachmentsService);

  @Input() capture: Capture;
  @Input() selectedAttachment: PatientAttachment;

  ngOnInit() {
    this.patientAttachmentsService.patientAttachmentChanged.subscribe(({ patientAttachment }) => {
      if (patientAttachment.id === this.selectedAttachment.id) {
        this.handlePatientAttachmentChange(patientAttachment);
      }
    });
  }

  private handlePatientAttachmentChange(patientAttachment: PatientAttachment) {
    this.patientAttachmentsService
      .getStatus(patientAttachment.id)
      .subscribe((result) => {
        patientAttachment.hasMatchingSpecialtyPmvs = result.hasMatchingSpecialtyPmvs;
        this.selectedAttachment = patientAttachment;
      });
  }
}
